<template>
  <CFooter :fixed="true">
    <div>
      <small>
        <span target="_blank">&copy; {{new Date().getFullYear()}} &nbsp;</span>
        <a href="https://www.heig-vd.ch">HEIG-VD</a>
      </small>
    </div>
    <div class="ml-auto">
      <small>
        <span class="mr-1" target="_blank">Contact: J. Ehrensberger</span>
      </small>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
